module.exports = __webpack_public_path__ + "static/media/erroricon.4981479a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erroricon.svg
// module id = 2436
// module chunks = 0